import React from 'react';
import { createPortal } from 'react-dom';

import { ToastContainer } from 'react-toastify';

const ModalToastContainer = () =>
  createPortal(<ToastContainer position="top-right" />, document.body);

export default ModalToastContainer;
